"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M-.01 14c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V7h-16v7zm15-10H7.41L5.7 2.3a.965.965 0 00-.71-.3h-4c-.55 0-1 .45-1 1v3h16V5c0-.55-.45-1-1-1z"];
//# sourceMappingURL=folder-close.js.map